import { render, staticRenderFns } from "./classroom_view.vue?vue&type=template&id=4034e85a&scoped=true&"
import script from "./classroom_view.vue?vue&type=script&lang=js&"
export * from "./classroom_view.vue?vue&type=script&lang=js&"
import style0 from "./classroom_view.vue?vue&type=style&index=0&id=4034e85a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4034e85a",
  null
  
)

export default component.exports